var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Configures the selection behavior of the TreeGrid.
 */
export class SelectionSettings extends ChildProperty {
}
__decorate([
    Property('Row')
], SelectionSettings.prototype, "mode", void 0);
__decorate([
    Property('Flow')
], SelectionSettings.prototype, "cellSelectionMode", void 0);
__decorate([
    Property('Single')
], SelectionSettings.prototype, "type", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "persistSelection", void 0);
__decorate([
    Property('Default')
], SelectionSettings.prototype, "checkboxMode", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "checkboxOnly", void 0);
__decorate([
    Property(true)
], SelectionSettings.prototype, "enableToggle", void 0);
